import axios from "axios";
import { baseUrl, baseUrlAccount } from "../env";
//获取token
function getCookie(name) {
  let cookieList = document.cookie ? document.cookie.split(";") : [];
  let cookies = {};
  cookieList.forEach((item) => {
    if (!cookies[item.split("=")[0].trim()]) {
      cookies[item.split("=")[0].trim()] = item.split("=")[1];
    }
  });
  return cookies[name];
}

//axios配置
let http = axios.create({
  baseURL: baseUrl,
  withCredentials: false,
  timeout: 60000,
  headers: {
    tag: "11",
  },
});

http.interceptors.request.use((config) => {
  if (window.localStorage.getItem("fltrp-home-token")) {
    config.headers.token = getCookie("token");
    config.headers.userId = getCookie("user-idcon");
    return config;
  } else {
    window.location.href = "/";
  }
});

// axios拦截响应
http.interceptors.response.use(
  (r) => {
    if (r.data.status == 401) {
      if (window.location.hash != "#/401") {
        window.location.href = "/";
      }
    }
    // else if (r.data.status == 403 && window.location.hash != "#/403") {
    // window.location.href =
    //   window.location.origin + "/" + baseLinkName + "/student/#/403";
    // }
    return r.data;
  },
  (err) => {
    if (!err.response) {
      return {
        status: 500,
        msg: "如发生错误，请正常退出再登录或刷新。",
      };
    } else {
      // 登录状态
      if (err.response.status == 401 && window.location.hash != "#/401") {
        window.location.href = "/";
      } else if (err.response.status == 403) {
        window.location.href = "/";
      } else {
        return {
          status: 500,
          msg: "如发生错误，请正常退出再登录或刷新。",
        };
      }
    }
  }
);

//axios配置
let httpByGz = axios.create({
  baseURL: baseUrl,
  withCredentials: false,
  timeout: 60000,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    tag: "11",
  },
});

httpByGz.interceptors.request.use((config) => {
  if (window.localStorage.getItem("fltrp-home-token")) {
    config.headers.token = getCookie("token");
    config.headers.userId = getCookie("user-idcon");
    return config;
  } else {
    window.location.href = "/";
  }
});

// axios拦截响应
httpByGz.interceptors.response.use(
  (r) => {
    if (r.data.status == 401) {
      if (window.location.hash != "#/401") {
        window.location.href = "/";
      }
    }
    return r.data;
  },
  (err) => {
    if (!err.response) {
      return {
        status: 500,
        msg: "如发生错误，请正常退出再登录或刷新。",
      };
    } else {
      // 登录状态
      if (err.response.status == 401 && window.location.hash != "#/401") {
        window.location.href = "/";
      }
      // else if (
      //   err.response.status == 403 &&
      //   window.location.hash != "#/403"
      // ) {
      //   window.location.href = "/#/403";
      // }
      else {
        return {
          status: 500,
          msg: "如发生错误，请正常退出再登录或刷新。",
        };
      }
    }
  }
);

//axios配置
let noTokenHttp = axios.create({
  baseURL: baseUrl,
  withCredentials: false,
  timeout: 60000,
  headers: {
    tag: "11",
  },
});

// axios拦截响应
noTokenHttp.interceptors.response.use(
  (r) => {
    return r.data;
  },
  (err) => {
    if (!err.response) {
      return {
        status: 500,
        msg: "如发生错误，请正常退出再登录或刷新。",
      };
    }
  }
);

let accHttp = axios.create({
  baseURL: baseUrlAccount,
  withCredentials: false,
  timeout: 60000,
  // credentials: "include",
  // headers: {
  //   accept: "*/*",
  //   "content-type": "application/x-www-form-urlencoded",
  // },
});

accHttp.interceptors.request.use((config) => {
  if (window.localStorage.getItem("fltrp-home-token")) {
    config.headers.authorization =
      (window.localStorage.getItem("fltrp-home-tokenType") || "Bearer") +
      " " +
      getCookie("token");
    config.headers.appCode = "gaozhen";
    return config;
  } else {
    window.location.href = "/";
  }
});
// axios拦截响应
accHttp.interceptors.response.use(
  (r) => {
    return r.data;
  },
  (err) => {
    if (!err.response) {
      return {
        status: 500,
        msg: "如发生错误，请正常退出再登录或刷新。",
      };
    }
  }
);
export { http, httpByGz, noTokenHttp, accHttp };
